const BillingSummary = () =>
  import('@/components/Organisations/Billing/OldBilling');

export default {
  title: 'Billing',
  link: '/configuration/legacy-billing',

  permission: [
    {
      action: 'manage',
      entity: 'system'
    }
  ],
  meta: {
    permission: [
      {
        action: 'manage',
        entity: 'system'
      }
    ],
    id: 'configuration__legacy-billing-tab'
  },
  path: 'legacy-billing',
  component: BillingSummary
};
